export const ADMIN_EMAIL = 'admin@lifty.com.br';

export const AUTH0_AUDIENCE = 'https://lifty.us.auth0.com/api/v2/';

export const AUTH0_SCOPE = 'read:current_user update:current_user_metadata';

export const isAdminUser = (email) => email === ADMIN_EMAIL;
